











































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import ContactDto from '@/models/Contacts/ContactDto';
import CreateContactRequest from '@/models/Contacts/CreateContactRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import LocationDto from '@/models/Locations/LocationDto';
import PositionDto from '@/models/Positions/PositionDto';
import { AgencySettingsModule } from '@/store/modules/agencySettings';

@Component({
    name: 'CompanyContactCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new ContactDto();
  public locations: LocationDto[] = [];

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new ContactDto();
      if (CompanyDetailsModule.locations.length === 0) {
        //try loading locations
        await CompanyDetailsModule.getLocations();
      }
      if (AgencySettingsModule.positions.length === 0) {
        await AgencySettingsModule.getPositions();
      }
    }
  }

  @Watch('entity.position')
  async onPositionChanged(val: PositionDto, oldVal: PositionDto) {
    if (val) {
      this.entity.jobTitle = val.name;
    }
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  get loading() {
    return CompanyDetailsModule.loadingDialog;
  }

  get currentCompanyLocations() {
    return CompanyDetailsModule.locations;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateContactRequest()
    request.firstName = this.entity.person.firstName;
    request.lastName = this.entity.person.lastName;
    request.emailAddress = this.entity.emailAddress; 
    request.jobTitle = this.entity.jobTitle;
    request.positionId = this.entity.position.id;
    request.mobilePhoneNumber = this.entity.mobilePhoneNumber;
    request.otherPhoneNumber = this.entity.otherPhoneNumber;
    request.locationIds = this.locations.map(( {id }) => id);
    // request.canManageProfile = this.entity.canManageProfile;
    // request.canManageReports = this.entity.canManageReports;
    // request.canManageContacts = this.entity.canManageContacts;
    // request.canManageRoles= this.entity.canManageRoles
    // request.canManageLocations = this.entity.canManageLocations;
    // request.canManageBookings = this.entity.canManageBookings;
    // request.canManageWorkers = this.entity.canManageWorkers;
    // request.canManageTimesheets= this.entity.canManageTimesheets;
    await CompanyDetailsModule.createContact(request)
    this.dialog = false;
  }
}
